/* eslint-disable */
'use strict';
exports.__esModule = true;
exports.default = {
  "ERP_list": "ERP List",
  "ERP_qty": "ERP Qty",
  "account": "Account",
  "active": "Active",
  "active_date": "Active Date",
  "address": "Address",
  "address2": "Address 2 (Optional)",
  "amount": "Amount",
  "and": "and",
  "buyer": "Buyer",
  "buyer_info": "Buyer Information",
  "cancel": "Cancel",
  "cancel_input": "Cancel input",
  "canceled": "Canceled",
  "cell_phone": "Cell Phone",
  "cellphone": "Cell Phone",
  "change_password": "Change Password",
  "city": "City",
  "clear": "Clear",
  "close_the_page_without_saving": "Do you want to close the page without saving confirmation？",
  "company": "Company",
  "completed": "Completed",
  "confirm_password": "Confirm Password",
  "country": "Country",
  "create": "Create",
  "create_account": "Create Account",
  "created_date": "Created Date",
  "created_success": "Created successfully",
  "creationdate": "CreationDate",
  "currency": "Currency",
  "dash_board": "Dash Board",
  "dealer": "Dealer",
  "delete": "Delete",
  "delete_success": "Delete Success",
  "delete_tip1": "Are you sure to delete it?",
  "delete_tip2": "",
  "description": "Description",
  "disable": "Disable",
  "disabled_success": "Disabled successfully",
  "edit": "Edit",
  "email": "Email",
  "enable": "Enable",
  "enabled_success": "Enabled successfully",
  "enter_character": "Enter the characters in the picture",
  "enter_confirm_password": "Enter new password again",
  "enter_new_password": "Enter new password",
  "enter_old_password": "Enter old password",
  "enter_the_password_and_new_password": "Please enter the password and new password first！",
  "erp_list": "Subscriptions",
  "erp_status": "Status",
  "error": "Error",
  "exp_date": "Expire date",
  "expire_date": "Expire date",
  "first_name": "First Name",
  "forget_password": "Forget Password",
  "forgot_password": "Forgot password?",
  "group_code": "Group Code",
  "history_order_list": "History Order List",
  "home_company_address": "Home/Company Address",
  "image": "Image",
  "initial_info": "Initial Info",
  "input_password_again": "Please enter the password again",
  "last_name": "Last Name",
  "launch_success": "Launch successfully",
  "legal_perssion": "Legal Perssion",
  "logout": "Logout",
  "mail": "Mail",
  "modify": "Modify",
  "modify_order_": "Modify Order-",
  "modify_password": "Modify Password",
  "modify_product": "Modify Product",
  "modify_success": "Modify Success",
  "module_ID": "Module ID",
  "modules": "Modules",
  "moneyNumber_format_error": "MoneyNumber Format Error",
  "money_format_error": "Money Format Error",
  "name": "Name",
  "new": "NEW",
  "new_password": "New Password",
  "new_password_toEmail": "We have sent a new password to your email",
  "new_product": "New Product",
  "next": "Next",
  "noFoundurl1": "Instance doesn't exist",
  "number_of_users": "User Quantity",
  "off_the_shelf": "Off the shelf",
  "official_website": "Official Website:",
  "ok": "OK",
  "old_password": "Old Password",
  "old_password_error": "Old password doesn't match",
  "on_the_shelf": "On the shelf",
  "operation": "Operation",
  "or": "OR",
  "order": "Order",
  "order-no": "Order-No",
  "order_": "Order-",
  "order_list": "Order List",
  "order_no": "Order No",
  "order_status": "Order Status",
  "paid": "Paid",
  "password": "Password",
  "password_error_two": "The two input passwords are inconsistent!",
  "password_least": "The password is at least 6 digits long and contains numbers and letters/special characters",
  "password_must_be_the_same": "The confirmation password must be the same as the reset password！",
  "pay": "Pay",
  "pay_status": "Payment Status",
  "payment_date": "Payment Date",
  "personal": "Personal",
  "please_email": "Sent A password retrieval email, please pay attention to receiving the email",
  "please_sign_in_again": "Unauthorized or expired, please sign in again.",
  "pos": "Pos",
  "price": "Price",
  "privacy": "By creating a SOMATIME Account,Understand and agree to SOMATIME's",
  "privacy_notice": "Privacy Notice",
  "product": "Product",
  "product_list": "Product List",
  "product_name": "Product Name",
  "refunded": "Refunded",
  "registered_email_address": "We have registered width your email address",
  "remove_success": "Remove successfully",
  "repeat_password": "Repeat Password",
  "required": "Required",
  "reseller": "Reseller",
  "resend": "Resend",
  "revoke": "Revoke",
  "role": "Role",
  "search": "Search",
  "send_update": "Send me updates from SOMATIME",
  "sex": "Sex",
  "signIn": "Sign In",
  "state": "State/Province",
  "status": "Status",
  "status_discrepancy": "Status discrepancy",
  "submit": "Submit",
  "submitted": "Submitted",
  "subscribe-mon": "Subscribe-Mon",
  "subscribe_mon": "Subscribe Mon",
  "success": "Success",
  "sure_to_close": "Are you sure to close?",
  "telephone": "Telephone",
  "tenant_list": "Tenant List",
  "tenant_management_system": "TENANT MANAGEMENT SYSTEM",
  "tenant_system": "TENANT SYSTEM",
  "terms_of_use": "Terms of Use",
  "test": "test",
  "title": "Title",
  "unpaid": "Unpaid",
  "update_password_success": "The password was modified successfully",
  "user": "User",
  "user_check": "Please read and check the consent privacy statement and terms of use",
  "user_id": "User Id",
  "user_information": "User Information",
  "user_list": "User List",
  "user_month": "User/Month",
  "user_password_error": "Your username or password is wrong!",
  "user_qty": "User Qty",
  "username": "Username",
  "welcome_to_iceq": "WELCOME TO SOMATIME",
  "wrong_user_name_and_password": "Wrong user name and password！",
  "zip": "Zip",
  "trial": "Trial",
  "requesting_a_trial": "Requesting a trial",
  "trial_orders_have_been_requested": "Trial orders have been requested",
  "trial_orders_requested_success": "Trial order request approved",
  "apply_trial": "Request Demo",
  "on_trial": "on Trial",
  "order_not_exist": "Order not exist",
  "application_approved": "Approve",
  "wait_for_payment": "Wait for Payment",
  "instCount": "Number of Instances",
  "trial_orders_requested_reject": "Trial order request rejected",
  "application_reject": "Reject",
  "trial_reject": "Demo rejected",
};